import { render } from "./waitlist-joined.vue?vue&type=template&id=32720f34&scoped=true"
import script from "./waitlist-joined.vue?vue&type=script&lang=js"
export * from "./waitlist-joined.vue?vue&type=script&lang=js"

import "./waitlist-joined.vue?vue&type=style&index=0&id=32720f34&lang=scss&scoped=true"

import exportComponent from "/home/node/ks-web/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-32720f34"]])

export default __exports__